import type { FC } from 'react';
import { useEffect } from 'react';

import { Logger } from '../../../logger/Logger';
import { useCoreDispatch } from '../../../store/CoreStore';
import { useChatSlice } from '../../../store/slices/chat/selectors';
import { chatActions } from '../../../store/slices/chat/slice';
import { ChatTabType } from '../../../store/slices/chat/types';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { useIsLargerThanWide } from '../../../styles/hooks/media';
import { ChatConnected } from '../chat/ChatConnected';

import { ChatModal } from './ChatModal';

export const ChatModalConnected: FC = () => {
  const isChatDisabled = useConfigSlice.isChatDisabled();
  const { getSelectedTab, getIsChatClosed, getDisplayMiniChat } = useChatSlice;
  const title = getSelectedTab() === ChatTabType.GameChat ? 'CHAT' : 'LIVE_SUPPORT';
  const isChatModalOpen: boolean = !getIsChatClosed();
  const isChatClosedByUser: boolean = getDisplayMiniChat();
  const isLiveSupportOpen = useChatSlice.getIsLiveSupportOpen();

  const dispatch = useCoreDispatch();
  const isWideScreen: boolean = useIsLargerThanWide();

  // Hide chat modal on narrow screen devices on initialisation
  useEffect(() => {
    if (!isWideScreen) {
      dispatch(chatActions.setIsChatClosed(true));
    }
  }, [isWideScreen, dispatch]);

  // Hide modal when resizing window, if chat was closed by user
  useEffect(() => {
    if (isWideScreen && !isChatModalOpen && !isChatClosedByUser) {
      dispatch(chatActions.setIsChatClosed(false));
    }
  }, [dispatch, isWideScreen, isChatClosedByUser, isChatModalOpen]);

  const handleCloseModal = (): void => {
    dispatch(chatActions.setIsChatClosed(true));

    if (isWideScreen) {
      dispatch(chatActions.setDisplayMiniChat(true));
    }

    Logger.logEvent('click', 'chatModalClosed', Date.now(), 1, isLiveSupportOpen ? 'support' : '', false);
  };

  if (isChatDisabled) {
    return null;
  }

  return (
    <ChatModal isChatModalOpen={isChatModalOpen} onClose={handleCloseModal} title={title} fullScreenNoClose>
      <ChatConnected />
    </ChatModal>
  );
};
